export default "__VITE_ASSET__CA9LjiJY__"